import React, { useEffect, useState } from 'react';
import { consultarSaldoCajaMenorEmisor } from 'network/Api/SaldoDinero';
import ModalConfirmacion from './ModalConfirmacion';

const MENSAJE_SALDO_MENOR_A_DIEZMIL =
  '¡Alerta! Saldo próximo a agotarse. Recarga ahora para seguir disfrutando.';
const MENSAJE_SALDO_CERO = '¡Alerta! Saldo agotado. Recarga ahora para continuar disfrutando.';

function ModalNotificacionSaldo({ idEmisor, tarifa }) {
  const [state, setState] = useState({});

  useEffect(() => {
    if (idEmisor) {
      consultarSaldoEmisor();
    }
  }, [idEmisor]);
  async function consultarSaldoEmisor() {
    const result = await consultarSaldoCajaMenorEmisor({ emisor: idEmisor });

    if (result.data > 0 && result.data <= 10000) {
      setState({ open: true, content: MENSAJE_SALDO_MENOR_A_DIEZMIL });
    }

    if (parseInt((result.data / tarifa).toFixed(0)) === 0) {
      setState({ open: true, content: MENSAJE_SALDO_CERO });
    }
  }

  function cerrarModal() {
    setState((oldState) => {
      return { ...oldState, open: false };
    });
  }

  return <ModalConfirmacion open={state.open} content={state.content} onAccept={cerrarModal} />;
}

export default ModalNotificacionSaldo;
